/** Chuỗi của "Tiền bo" (KH-GĐ2 5.2). Tiếng Việt có dấu, câu ngắn. */
export const B = {
  mo: 'Khách bo thợ',
  tieuDe: 'Tiền bo cho thợ',
  giaiThich: 'Không tính vào doanh thu, không tính hoa hồng.',
  soTien: 'Khách bo bao nhiêu',
  thoNhan: 'Thợ nhận',
  cachDua: 'Khách đưa bằng',
  tienMatTay: 'Tiền mặt (đưa tay thợ)',
  chuyenKhoan: 'Chuyển khoản',
  the: 'Quẹt thẻ',
  chiaDeu: (n: number) => (n > 1 ? `Chia đều cho ${n} người.` : ''),
  nhapTay: 'Nhập tay từng người',
  chiaDeuLai: 'Chia đều',
  tiemNo: 'Tiền vào tài khoản tiệm — tiệm sẽ trả lại thợ bằng tiền mặt.',
  lechTong: 'Tổng từng người chưa bằng số khách bo.',
  chuaCoTho: 'Lịch chưa gắn thợ nào nên chưa ghi bo được.',
  // Sổ tiền → Hôm nay
  soTitle: 'Tiền bo hôm nay',
  soPhu: 'Bo qua chuyển khoản / thẻ vào tài khoản tiệm — tiệm trả lại thợ bằng tiền mặt.',
  dongTho: (tm: string, ck: string, the: string) =>
    [
      tm !== '' ? `tiền mặt ${tm}` : '',
      ck !== '' ? `chuyển khoản ${ck}` : '',
      the !== '' ? `thẻ ${the}` : '',
    ]
      .filter((x) => x !== '')
      .join(' · '),
  conNo: (tien: string) => `Tiệm còn nợ ${tien}`,
  daTraDu: 'Đã trả đủ',
  thoNoLai: (tien: string) => `Thợ đã nhận dư ${tien}`,
  // Động từ, không phải trạng thái: "Đã trả …" đọc như việc đã xong.
  traNut: (tien: string) => `Trả thợ ${tien}`,
  daTra: (ten: string, tien: string) => `Đã ghi trả ${ten} ${tien} tiền bo.`,
  // Sửa lần trả bấm nhầm (money-auditor 5.2 N3).
  daTraLan: (tien: string) => `Đã trả ${tien}`,
  traNham: 'Trả nhầm',
  traNhamHoi: (ten: string, tien: string) => `Bỏ lần trả ${ten} ${tien}? Két cộng lại số này.`,
  traNhamLyDo: 'Trả nhầm',
  boLanTra: 'Bỏ lần trả này',
  thoi: 'Thôi',
  daBoLanTra: 'Đã bỏ lần trả nhầm. Két cộng lại số đó.',
  daSuaTra: 'đã bỏ',
  chiNhanhTra: 'Lấy tiền từ két chi nhánh',
  // Việc của tôi
  cuaToi: (homNay: string, thang: string) => `Tiền bo: hôm nay ${homNay} · tháng này ${thang}`,
  cuaToiNo: (tien: string) => `Tiệm còn giữ ${tien} tiền bo của bạn.`,
} as const
